<div class="list">
  <playlist />
</div>
<navigator />
